<template>
    <div id="transcription">
        <div class="transcription-position">
            <div class="rec-session clickable" @click="openTranscription()">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4.32812 16.1719C5.92188 17.7344 7.8125 18.5156 10 18.5156C12.1875 18.5156 14.0625 17.7344 15.625 16.1719C17.2188 14.5781 18.0156 12.6875 18.0156 10.5C18.0156 8.3125 17.2188 6.4375 15.625 4.875C14.0625 3.28125 12.1875 2.48438 10 2.48438C7.8125 2.48438 5.92188 3.28125 4.32812 4.875C2.76562 6.4375 1.98438 8.3125 1.98438 10.5C1.98438 12.6875 2.76562 14.5781 4.32812 16.1719ZM2.92188 3.46875C4.89062 1.5 7.25 0.515625 10 0.515625C12.75 0.515625 15.0938 1.5 17.0312 3.46875C19 5.40625 19.9844 7.75 19.9844 10.5C19.9844 13.25 19 15.6094 17.0312 17.5781C15.0938 19.5156 12.75 20.4844 10 20.4844C7.25 20.4844 4.89062 19.5156 2.92188 17.5781C0.984375 15.6094 0.015625 13.25 0.015625 10.5C0.015625 7.75 0.984375 5.40625 2.92188 3.46875ZM6.4375 6.98438C7.4375 5.98438 8.625 5.48438 10 5.48438C11.375 5.48438 12.5469 5.98438 13.5156 6.98438C14.5156 7.95312 15.0156 9.125 15.0156 10.5C15.0156 11.875 14.5156 13.0625 13.5156 14.0625C12.5469 15.0312 11.375 15.5156 10 15.5156C8.625 15.5156 7.4375 15.0312 6.4375 14.0625C5.46875 13.0625 4.98438 11.875 4.98438 10.5C4.98438 9.125 5.46875 7.95312 6.4375 6.98438Z"
                        fill="white"/>
                </svg>
                <div class="rec_text">{{ $t('transcription.recording_session') }}</div>
            </div>
            <div class="rec-session clickable" v-if="this.user_type == 'moderator'" @click="openTranscriptions">
                <svg width="20" height="20" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M26.8333 17.5C26.2777 17.5 25.8055 17.3056 25.4166 16.9167C25.0277 16.5278 24.8333 16.0556 24.8333 15.5V12.1667C24.8333 11.6111 25.0277 11.1389 25.4166 10.75C25.8055 10.3611 26.2777 10.1667 26.8333 10.1667C27.3888 10.1667 27.861 10.3611 28.2499 10.75C28.6388 11.1389 28.8333 11.6111 28.8333 12.1667V15.5C28.8333 16.0556 28.6388 16.5278 28.2499 16.9167C27.861 17.3056 27.3888 17.5 26.8333 17.5ZM26.1666 22.1667V20.1C25.0333 19.9222 24.0833 19.4056 23.3166 18.55C22.5499 17.6945 22.1666 16.6778 22.1666 15.5H23.4999C23.4999 16.4333 23.8221 17.2222 24.4666 17.8667C25.111 18.5111 25.8999 18.8333 26.8333 18.8333C27.7666 18.8333 28.5555 18.5111 29.1999 17.8667C29.8444 17.2222 30.1666 16.4333 30.1666 15.5H31.4999C31.4999 16.6778 31.1166 17.6945 30.3499 18.55C29.5833 19.4056 28.6333 19.9222 27.4999 20.1V22.1667H26.1666ZM11.4999 11.5C10.0333 11.5 8.7777 10.9778 7.73325 9.93334C6.68881 8.8889 6.16658 7.63334 6.16658 6.16668C6.16658 4.70001 6.68881 3.44445 7.73325 2.40001C8.7777 1.35557 10.0333 0.833344 11.4999 0.833344C11.811 0.833344 12.1166 0.855566 12.4166 0.90001C12.7166 0.944455 13.011 1.02223 13.2999 1.13334C12.7221 1.82223 12.2777 2.59445 11.9666 3.45001C11.6555 4.30557 11.4999 5.21112 11.4999 6.16668C11.4999 7.12223 11.6555 8.02779 11.9666 8.88334C12.2777 9.7389 12.7221 10.5111 13.2999 11.2C13.011 11.3111 12.7166 11.3889 12.4166 11.4333C12.1166 11.4778 11.811 11.5 11.4999 11.5ZM0.833252 22.1667V18.4667C0.833252 17.7111 1.02214 17.0111 1.39992 16.3667C1.7777 15.7222 2.29992 15.2333 2.96659 14.9C3.81103 14.4556 4.7277 14.0722 5.71658 13.75C6.70547 13.4278 7.78881 13.1778 8.96658 13C8.0777 13.6222 7.38881 14.4111 6.89992 15.3667C6.41103 16.3222 6.16658 17.3556 6.16658 18.4667V22.1667H0.833252ZM19.4999 11.5C18.0333 11.5 16.7777 10.9778 15.7333 9.93334C14.6888 8.8889 14.1666 7.63334 14.1666 6.16668C14.1666 4.70001 14.6888 3.44445 15.7333 2.40001C16.7777 1.35557 18.0333 0.833344 19.4999 0.833344C20.9666 0.833344 22.2221 1.35557 23.2666 2.40001C24.311 3.44445 24.8333 4.70001 24.8333 6.16668C24.8333 7.63334 24.311 8.8889 23.2666 9.93334C22.2221 10.9778 20.9666 11.5 19.4999 11.5ZM19.4999 8.83334C20.2333 8.83334 20.861 8.57223 21.3833 8.05001C21.9055 7.52779 22.1666 6.90001 22.1666 6.16668C22.1666 5.43334 21.9055 4.80557 21.3833 4.28334C20.861 3.76112 20.2333 3.50001 19.4999 3.50001C18.7666 3.50001 18.1388 3.76112 17.6166 4.28334C17.0944 4.80557 16.8333 5.43334 16.8333 6.16668C16.8333 6.90001 17.0944 7.52779 17.6166 8.05001C18.1388 8.57223 18.7666 8.83334 19.4999 8.83334ZM8.83325 22.1667V18.4667C8.83325 17.7111 9.02214 17.0111 9.39992 16.3667C9.7777 15.7222 10.2999 15.2333 10.9666 14.9C12.0999 14.3222 13.3833 13.8333 14.8166 13.4333C16.2499 13.0333 17.811 12.8333 19.4999 12.8333C19.7666 12.8333 20.0277 12.8389 20.2833 12.85C20.5388 12.8611 20.7888 12.8778 21.0333 12.9C20.811 13.3 20.6277 13.7167 20.4833 14.15C20.3388 14.5833 20.2444 15.0333 20.1999 15.5H19.4999C17.8999 15.5 16.4833 15.7 15.2499 16.1C14.0166 16.5 12.9999 16.9 12.1999 17.3C11.9777 17.4111 11.8055 17.5722 11.6833 17.7833C11.561 17.9945 11.4999 18.2222 11.4999 18.4667V19.5H21.0666C21.3999 20.0778 21.811 20.5889 22.2999 21.0333C22.7888 21.4778 23.3333 21.8556 23.9333 22.1667H8.83325Z"
                        fill="white"/>
                </svg>
            </div>
            <speech ref="speech"/>
        </div>
        <div v-if="open_transcription" class="ui transcriptionSideBar">
            <i class="close icon" @click="open_transcription=false"></i>
            <div class="header">
                {{$t("transcription.transcription")}}
                <!--                <div class="ui selection suidropdown" id="lang_transcription_dropdown">
                                    <input v-model="lang_transcription" type="hidden" name="lang_transcription">
                                    <i class="dropdown icon"></i>
                                    <div class="text">
                                        <div class="item active">
                                            <i class="br flag"></i> Português
                                        </div>
                                    </div>
                                    <div class="menu">
                                        <div class="item" :class="{active:lang_transcription=='pt-BR'}" @click.prevent.stop="lang_transcription='pt-BR'">
                                            <i class="br flag"></i> Português
                                        </div>
                                        <div class="item" :class="{active:lang_transcription=='en-US'}" @click.prevent.stop="lang_transcription='en-US'">
                                            <i class="us flag"></i> Inglês
                                        </div>
                                        <div class="item" :class="{active:lang_transcription=='es-ES'}" @click.prevent.stop="lang_transcription='es-ES'">
                                            <i class="es flag"></i> Espanhol
                                        </div>
                                        <div class="item" :class="{active:lang_transcription=='fr-FR'}" @click.prevent.stop="lang_transcription='fr-FR'">
                                            <i class="fr flag"></i> Francês
                                        </div>
                                    </div>
                                </div>-->
            </div>
            <!--            tabs fomantic-->
            <div class="ui top secondary pointing equal width fluid menu">
                <a class="item" :class="{active:tab==='chat'}" @click="tab='chat'">{{$t("transcription.transcribed_chat")}}</a>
                <a class="item" :class="{active:tab==='summary'}" @click="tab='summary'">{{$t("transcription.intelligent_summary")}}</a>
            </div>
            <div v-if="tab === 'chat'" class="d-flex flex-column h-100 w-100">
                <div class="ui grid header-chat">
                    <div class="eleven wide column">
                        <h3>
                            {{ $t('transcription.transcribed_chat') }}
                        </h3>
                    </div>
                    <div class="five wide column">
                        <a @click="downloadFileHandler()">
                            <i class="download icon"></i>
                            {{ $t('transcription.download') }}
                        </a>
                    </div>
                </div>
                <div ref="scrollableTranscription" id="scrollableTranscription" class="content h-100"
                     @scroll="onScroll">
                    <div ref="contentTranscription" class="ui list">
                        <div class="item" v-for="transcription in opened_transcription" :key="transcription.id">
                            <strong>@{{ transcription.nickname }} {{ transcription.created_at.split(" ").pop() }}&nbsp;&nbsp;</strong>
                            <span>{{ transcription.content }}</span>
                        </div>
                    </div>
                </div>
<!--                enviar mensagem -->
<!--                <div class="w-100 mt-3 ">
                    <div class="ui fluid input">
                        <input ref="input_message" type="text" placeholder="Digite a sua mensagem..." @keyup.enter="addMessage('',true)">
&lt;!&ndash;                        icon send&ndash;&gt;
                        <a class="d-flex align-items-center" @click="addMessage('',true)">
                            <svg width="37" height="37" viewBox="0 -4 37 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.6875 24V14.6875L24.6875 12L4.6875 9.3125V0L32.6875 12L4.6875 24Z" fill="#00A34C"/>
                            </svg>
                        </a>
                    </div>
                </div>-->
            </div>
            <SmartSummary v-if="tab === 'summary'"/>
        </div>
        <div>
            <div id="dimmerTranscription" v-if="this.user_type == 'moderator'" class="ui modals page dimmer">
                <!--            modal from fomantic-->
                <div class="ui translucent suimodal" id="transcription_modal">
                    <i class="close icon"></i>
                    <div class="header">
                        {{$t("transcription.my_transcriptions")}}
                    </div>
                    <div class="content">
                        <div class="ui grid">
                            <div class="five wide column">
                                <strong>{{ transcriptions.length }} {{ $t('transcription.transcriptions') }}</strong>
                            </div>
                            <div class="five wide column">
                            </div>
                            <div class="six wide column">
                                <select class="ui suidropdown w-100" v-model="session" @change="findTranscriptions">
                                    <option value="">{{ $t('transcription.select_a_session') }}</option>
                                    <option v-for="session in sessions" :key="session.id" :value="session.id">
                                        {{ session.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="ui list">
                            <div v-for="transcription in transcriptions" :key="transcription.id" class="item">
                                <!--created_at, last update at, download-->
                                <div class="ui grid">
                                    <div class="five wide column">
                                        {{ transcription.created_at }}
                                    </div>
                                    <div class="five wide column">
                                        {{ transcription.last_transcription }}
                                    </div>
                                    <div class="six wide column">
                                        <a @click="downloadFileHandler(transcription.id)">
                                            <svg width="18" height="20" viewBox="0 0 18 20" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g filter="url(#filter0_d_3_294)">
                                                    <path
                                                        d="M4.34375 11.3438V10H13.6562V11.3438H4.34375ZM13.6562 4L9 8.65625L4.34375 4H7V0H11V4H13.6562Z"
                                                        fill="white"/>
                                                </g>
                                            </svg>
                                            {{ $t('transcription.baixar') }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import Speech from "@/components/avia/Speech.vue";
import SmartSummary from "@/components/avia/SmartSummary.vue";
import axios from "axios";

let emitter = require('tiny-emitter/instance');
export default {
    name: 'Transcription',
    components: {Speech, SmartSummary},
    data() {
        return {
            avia: {
                scenario: 'speechRecognizerContinuous',
                recognition_language: 'pt-BR',
            },
            // current_content: '',
            session: '',
            mic_on: false,
            transcription_id: null,
            transcriptions: [],
            open_transcription: false,
            lang_transcription: 'pt-BR',
            isAtBottom: true,
            current_scroll: 0,
            tab: 'chat',
        }
    },
    computed: {
        ...mapGetters([
            'current_session', 'token', 'id', 'user_type', 'sessions'
        ]),
        ...mapGetters('Transcription', [
            'opened_transcription', 'messages_chat'
        ]),
        chat_room() {
            //chat room in APP
            return this.$app.chat_room;
        },
    },
    mounted() {
        this.mic_on = !this.current_session.agora_io.start_muted;
        this.avia.recognition_language = this.current_session.transcription_language??'pt-BR' ;
        this.$refs.speech.start();
        emitter.on('unity_message::agora_mic_muted', muted => {
            this.micMuted(muted);
        });
        emitter.on('chat::admin::transcription_message', payload => {
            if (!this.open_transcription) return;
            if (this.opened_transcription.indexOf(_ => _.id == payload.id) == -1) {
                this.transcription_id = payload.transcription_id
                let openTrans = this.opened_transcription;
                openTrans.push({
                    content: payload.content,
                    created_at: payload.created_at,
                    nickname: payload.nickname,
                    photo: payload.photo,
                    transcription_id: payload.transcription_id,
                    id: payload.id
                });
                this.setOpenedTranscription(openTrans.sort((a, b) => (a.id > b.id) ? 1 : -1));
            }
        });
    },
    beforeUpdate() {
        this.handleScroll();
    },
    updated() {
        if ($('#lang_transcription_dropdown').length > 0) {
            $('#lang_transcription_dropdown').suidropdown();
        }
        this.scrollBottom();
    },
    beforeDestroy() {
        emitter.off('unity_message::agora_mic_muted');
        emitter.off('chat::admin::transcription_message');
    },
    methods: {
        ...mapActions('Transcription', [
            'setOpenedTranscription'
        ]),
        onScroll() {
            this.current_scroll = this.$refs.scrollableTranscription.scrollTop ?? 0;
        },
        scrollBottom() {
            const scrollable = this.$refs.scrollableTranscription;
            const content = this.$refs.contentTranscription;
            if (scrollable && content) {
                if (this.isAtBottom) {
                    scrollable.scrollTop = content.scrollHeight - scrollable.clientHeight;
                } else {
                    scrollable.scrollTop = this.current_scroll;
                }
            }
        },
        handleScroll() {
            const scrollable = this.$refs.scrollableTranscription;
            const content = this.$refs.contentTranscription;
            if (scrollable && content) {
                this.isAtBottom = scrollable.scrollTop + scrollable.clientHeight >= content.scrollHeight;
            }
        },
        micMuted(data) {
            this.mic_on = !data;
            this.$refs.speech.toggleReco();
        },
        downloadFileHandler(id) {
            if (this.user_type === 'moderator' && id) {
                let url = `${this.$url_api}api/transcriptions/download/${id}`;
                let data = {};
                this.downloadFile(url, data, id);
            } else {
                let url = `${this.$url_api}api/transcriptions/download`;
                let data = {
                    session_id: this.current_session.id,
                    chat_room: this.chat_room,
                };
                this.downloadFile(url, data);
            }
        },
        downloadFile(url, data, id) {
            let root = this;
            axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access': 'application/json',
                    language: root.$i18n.locale,
                    Authorization: `Bearer ${root.token}`
                },
                responseType: 'blob'
            })
                .then(response => {
                    let url = window.URL.createObjectURL(new Blob([response.data]));
                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `transcription_${id ?? this.chat_room}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        openTranscriptions() {
            if (this.user_type !== 'moderator') return;
            /* global $ */
            this.findTranscriptions().then(() => {
                $('#dimmerTranscription').dimmer('show');
                $('#transcription_modal').suimodal({
                    context: '#dimmerTranscription',
                }).suimodal('show');
            });
        },
        findTranscriptions() {
            let root = this;
            return new Promise((resolve, reject) => {
                let params = {};
                if (this.session) {
                    params.session_id = root.session;
                }
                axios.get(`${root.$url_api}api/transcriptions/moderator`, {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'Access': 'application/json',
                        language: root.$i18n.locale,
                        Authorization: `Bearer ${root.token}`
                    },
                    params
                })
                    .then(response => {
                        root.transcriptions = response.data.data.transcriptions;
                        resolve(response.data.data.transcriptions);
                    })
                    .catch(error => {
                        console.log(error);
                        reject();
                    });
            });
        },
        openTranscription() {
            this.open_transcription = false;
            axios.get(`${this.$url_api}api/transcriptions`, {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access': 'application/json',
                    language: this.$i18n.locale,
                    Authorization: `Bearer ${this.token}`
                },
                params: {
                    session_id: this.current_session.id,
                    chat_room: this.chat_room,
                }
            }).then(response => {
                this.setOpenedTranscription(response.data.data.transcriptionData ?? []);
                this.open_transcription = true;
            }).catch(error => {
                console.log(error);
            });
        },
        addMessage(content,input=false) {
            if (input) {
                content = this.$refs.input_message.value;
                this.$refs.input_message.value = '';
            }
            let root = this;
            let data = {
                session_id: this.current_session.id,
                chat_room: this.chat_room,
                content,
                input
            };
            // this.current_content = content;
            if (this.transcription_id) {
                data.transcription_id = this.transcription_id;
            }
            axios.post(`${this.$url_api}api/transcriptions/upload`, data, {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access': 'application/json',
                    language: this.$i18n.locale,
                    Authorization: `Bearer ${this.token}`
                }
            })
                .then(response => {
                    root.transcription_id = response.data.data.transcription_id;
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
}
</script>

<style scoped lang="scss">
.transcription-position {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: flex-end;
}

.rec-session {
    padding: 10px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: Exo, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 20px;

    &.clickable {
        cursor: pointer;
    }
}

.suimodal {
    padding: 64px 44px;

    .icon.close {
        top: 54px;
        right: 44px;
        color: #fff;
    }

    .text-left {
        text-align: left;
    }
}

.transcriptionSideBar {
    position: absolute;
    top: 0;
    right: 0;
    width: min(600px ,40vw);
    max-width: 100%;
    max-height: calc(100vh - var(--headers_height));
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(20px);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 32px 64px;
    color: #fff;
    font-family: Exo, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 20px;
    h1, h2, h3, span,div,p,strong {
        font-family: Exo, sans-serif;
    }
    @media screen and (max-width: 1000px) {
        height: calc(100vh - var(--headers_height));
        width: 100%;
    }

    > i.close {
        align-self: flex-end;
        font-size: 2rem;
        margin-bottom: 20px;
        cursor: pointer;
    }

    .header {
        font-size: 1.75rem;
        font-weight: 700;
        line-height: 29px;
        margin-bottom: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        select {
            margin-left: 20px;
            background-color: #fff;
            color: #343434;
            border: none;
            font-size: .75rem;
            font-weight: 400;
            line-height: 1.5;
            padding: 10px 20px;
            border-radius: 10px;
            cursor: pointer;

            option {
                background-color: #fff;
                color: #343434;
            }
        }
    }
    > .ui.menu {
        .item {
            color: rgba(255, 255, 255, 0.3);
            border-bottom: 1px solid rgba(255, 255, 255, 0.3);
            &:hover {
                color: rgba(255, 255, 255, 0.5)!important;
                border-bottom: 1px solid rgba(255, 255, 255, 0.5);
            }
            &.active {
                &:hover {
                    color: #fff;
                    border-color: #fff;
                }
                color: #fff;
                border-color: #fff;
            }
        }
    }
    .content {
        overflow: auto;
    }
}

#transcription_modal {
    .content {
        max-height: 300px;
        overflow: auto;
    }
}
#scrollableTranscription {
    flex: 1 0 0;
    text-shadow: rgba(0,0,0,0.5) 0 4px 4px;
    .ui.list {
        .item{
            margin-bottom: 5px;
            font-size: 1rem;
            max-width: 95%;
            strong{
                font-weight: 700;
            }
        }
    }
}
.header-chat{
    padding: 0;
    margin-top: .75rem;
    margin-bottom: .75rem;
    .column{
        display: flex!important;
        align-items: center;
        &.five{
            justify-content: flex-end;
        }
        &.eleven{
            justify-content: flex-start;
        }
    }
    h3{
        font-size: 1.75rem;
        font-weight: 500;
        line-height: 1.5;
    }
    a{
        color: #fff;
        font-size: .75rem;
        font-weight: 400;
        line-height: 1.5;
        gap: 8px;
        cursor: pointer;
        text-decoration: none;
    }

}
</style>
<style lang="scss">
#transcription {
    /* Works on Firefox */
    * {
        scrollbar-width: initial;
        scrollbar-color: initial;
    }

    @-moz-document url-prefix() {
        * {
            scrollbar-width: thin;
            scrollbar-color: var(--buttons_color) rgba(0, 0, 0, 0.5);
        }
    }


    /* Works on Chrome, Edge, and Safari */
    *::-webkit-scrollbar {
        width: 10px;
    }

    *::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 5px;
    }

    *::-webkit-scrollbar-thumb {
        background-color: var(--buttons_color);
        border-radius: 5px;
    }
}
</style>